// Sectiunea "Pronosticuri Cote Mari" — vizibila pentru toate conturile.
// Se poate bloca din /apanel (doc Firestore appSettings/highOddsAI -> { enabled: boolean }).
export const DEFAULT_HIGH_ODDS_AI_ENABLED = true;
